export const FLOWCODE_PIXEL_ID_QUERY_PARAM = 'fc_pid'
